"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ConfidenceNumberGaugeDesktop_1 = __importDefault(require("./ConfidenceNumberGaugeDesktop"));
const ConfidenceNumberGaugeMobile_1 = __importDefault(require("./ConfidenceNumberGaugeMobile"));
class ConfidenceNumberGauge extends React.Component {
    render() {
        const mq = window.matchMedia("(max-width: 768px)");
        return (React.createElement(React.Fragment, null, mq.matches ? (React.createElement(ConfidenceNumberGaugeMobile_1.default, Object.assign({}, this.props))) : (React.createElement(ConfidenceNumberGaugeDesktop_1.default, Object.assign({}, this.props)))));
    }
}
exports.default = ConfidenceNumberGauge;
//# sourceMappingURL=ConfidenceNumberGauge.js.map